import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {CardActionArea} from 'views/components';
import {translate} from 'views/module';

import CardBody from './CardBody';

import moment from 'moment';

// The card links by Loom's client id, because intake leads created in Loom have no legacy RN.
const Card = (props) => {
  const {item} = props;

  const clientCareplan = item.clientCarePlan;
  const clientStatusLog = item.clientLastLogStatusUpdate;
  const clientId = item.clientId;
  const clientName = item.clientName;
  const clientCreatedAt = item.createdAt;
  const status = item.status;
  const callStatus = item.clientCallStatus?.introCallStatus;
  const leadQuality = clientCareplan?.leadQuality;

  const clientRelationships = React.useMemo(() => {
    const relationships = Object.values(item.relationships ?? {});
    if (!relationships.length) return [];

    return relationships.slice().sort((a, b) => {
      if (a.priority !== b.priority) return a.priority - b.priority;
      return a.name.localeCompare(b.name);
    });
  }, [item.relationships]);

  const primaryRelationship = clientRelationships[0];
  const notSetLabel = translate('loomLead.LoomLeadList.Card.SubtitleValue.NotSet');
  const clientLocation = clientCareplan?.generalInformation?.address || notSetLabel;
  const clientCreatedAtLabel = clientCreatedAt ? moment(clientCreatedAt).format('MMM D, YYYY') : '-';
  const caregiverCount = Object.keys(item.caregivers ?? {}).length;

  const clientDaysInStage = React.useMemo(() => {
    if (!clientStatusLog) {
      return Math.floor(moment().diff(moment(clientCreatedAt), 'days', true));
    } else {
      return Math.floor(moment().diff(moment(clientStatusLog.createdAt), 'days', true));
    }
  }, [clientStatusLog, clientCreatedAt]);

  const clientDaysInStageText = React.useMemo(() => {
    return translate(
        `loomLead.LoomLeadList.Card.SubtitleValue.${clientDaysInStage === 1 ? 'Day' : 'Days'}`,
        {number: clientDaysInStage},
    );
  }, [clientDaysInStage]);

  return (
    <CardActionArea
      sx={{
        height: '100%',
        textAlign: 'left',
        width: '100%',
        minWidth: 0,
      }}
      to={`/loom_lead/${clientId}`}
    >
      <CardBody
        callStatus={callStatus}
        caregiverCount={caregiverCount}
        clientCreatedAtLabel={clientCreatedAtLabel}
        clientDaysInStageText={clientDaysInStageText}
        clientLocation={clientLocation}
        clientName={clientName}
        leadQuality={leadQuality}
        notSetLabel={notSetLabel}
        primaryRelationship={primaryRelationship}
        status={status}
      />
    </CardActionArea>
  );
};

Card.propTypes = {
  item: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Card));
